// Locker tiles rendered by the game's own renderer (identical look to the play camera): masks + colours on the Sneak's
// true self, hats on the Inspector. ?tiles=1 renders each to a transparent canvas and exposes the PNG data URLs on
// window.TILES for tools/shot/tiles.mjs to save into client/assets/ui/cos/<id>.webp. QA/build tool — not in play.

import * as THREE from "three";
import { glb } from "../render/assets";
import { Character, setClips } from "../render/chars";
import { toonify } from "../render/town";
import { SUN_DIR, SKY } from "../render/core";
import { COSMETICS } from "../meta/catalog";
import { SNEAK_COLOURS } from "../render/world";

export async function renderTiles(man: any): Promise<Record<string, string>> {
  const size = 256;
  const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, preserveDrawingBuffer: true });
  renderer.setSize(size, size); renderer.setPixelRatio(1);
  renderer.outputColorSpace = THREE.SRGBColorSpace; renderer.toneMapping = THREE.NoToneMapping; renderer.setClearColor(0, 0);
  const scene = new THREE.Scene();
  scene.add(new THREE.HemisphereLight(SKY, "#F0D2AC", 0.56 * Math.PI));
  const sun = new THREE.DirectionalLight("#FFF2DE", 0.64 * Math.PI); sun.position.copy(SUN_DIR).multiplyScalar(10); scene.add(sun);
  const cam = new THREE.PerspectiveCamera(24, 1, 0.1, 20);
  setClips(await glb("./assets/anim/clips.glb"));
  const sneak = await glb("./assets/" + man.chars.sneak.file), insp = await glb("./assets/" + man.chars.inspector.file);
  const out: Record<string, string> = {};
  const shoot = async (ch: Character, id: string, headShot: boolean, lift = 0.16, dist = 1.9) => {
    scene.add(ch.root); ch.play("idle", 0); ch.update(0.6); ch.root.updateMatrixWorld(true);
    const head = ch.model.getObjectByName("head")!.getWorldPosition(new THREE.Vector3());
    const target = headShot ? head.clone().add(new THREE.Vector3(0, lift, 0)) : new THREE.Vector3(0, 0.7 * ch.scale, 0);
    const d = headShot ? dist : 4.4;
    cam.position.copy(target).add(new THREE.Vector3(0.55, 0.35, 1).normalize().multiplyScalar(d)); cam.lookAt(target);
    renderer.render(scene, cam);
    out[id] = renderer.domElement.toDataURL("image/png");
    scene.remove(ch.root);
  };
  for (const c of COSMETICS) {
    if (c.kind === "mask") {
      const ch = new Character(sneak, { tier: "high", skin: 1, body: "#6B4AA0" });
      const g = await glb("./assets/" + man.cosmetics[c.id].file); const o = g.scene.clone(true); toonify(o, "high", true); ch.attach(o, "head");
      await shoot(ch, c.id, true);
    } else if (c.kind === "color") {
      const ch = new Character(sneak, { tier: "high", skin: 1, body: SNEAK_COLOURS[c.id] });
      const g = await glb("./assets/" + man.cosmetics.mask_classic.file); const o = g.scene.clone(true); toonify(o, "high", true); ch.attach(o, "head");
      await shoot(ch, c.id, false);
    } else if (c.kind === "hat") {
      const ch = new Character(insp, { tier: "high", skin: 2, hair: "hair_brown" });
      const g = await glb("./assets/" + man.cosmetics[c.id].file); const o = g.scene.clone(true); toonify(o, "high", true); ch.attach(o, "head");
      await shoot(ch, c.id, true, 0.34, 2.5);
    }
  }
  return out;
}
